import { render, staticRenderFns } from "./PlanSeleccionadoConfiguracion.vue?vue&type=template&id=63ad6675"
import script from "./PlanSeleccionadoConfiguracion.vue?vue&type=script&lang=js"
export * from "./PlanSeleccionadoConfiguracion.vue?vue&type=script&lang=js"
import style0 from "./PlanSeleccionadoConfiguracion.vue?vue&type=style&index=0&id=63ad6675&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports